(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   THEME SCRIPT
 *
 *   TABLE OF CONTENTS
 *   window load
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
    #window load
    -------------------------------------------------- */

	$(window).on('load', function() {

		$('a.collection').on('click', function(e){
			e.preventDefault();
		});
		
		$("a.collection, #mega-menu-wrapper").hover(
			function() {
				$('body').addClass('show-mega-menu__desktop');
			}, function() {
				$('body').removeClass('show-mega-menu__desktop');
			}
		);

	});



})(jQuery);
